<template>
    <Fragment>
        <configuratorsV2Component v-if="app.webVersion == 2" />
        <configuratorsV1Component v-else />
    </Fragment>
</template>

<script>
import { app } from "../../application.js";
import configuratorsV1Component from "./configurators.v1.vue";
import configuratorsV2Component from "./configurators.v2.vue";
import { Fragment } from "vue-fragment";


export default {
    name: "configuratorsComponent",
    data() {
        return {
            app: app,
        };
    },
    components: {
        Fragment,
        configuratorsV1Component,
        configuratorsV2Component
    }
};
</script>
